import type { ReactNode } from 'react'
import { cx } from '../cx'
import type { StateScale } from './EmptyState'

export type StateIllustration = 'connection' | 'empty' | 'folders' | 'documents' | 'cactus'

export function StateLayout({
  children,
  scale,
  illustration,
  className,
}: {
  readonly children: ReactNode
  readonly scale: StateScale
  readonly illustration?: StateIllustration | false | undefined
  readonly className?: string | undefined
}) {
  return (
    <div
      className={cx(
        scale === 'page'
          ? 'mx-auto flex w-full max-w-md flex-col items-center gap-5 py-8'
          : 'flex flex-col items-start gap-3',
        className,
      )}
    >
      {scale === 'page' && illustration ? (
        <img
          src={`/illustrations/${illustration}.svg`}
          alt=""
          aria-hidden="true"
          width={240}
          height={200}
          className="block h-28 w-36 shrink-0 object-contain sm:h-32 sm:w-40"
        />
      ) : null}
      <div
        className={cx(
          'flex min-w-0 flex-col gap-3',
          scale === 'page' ? 'items-center text-center' : 'items-start text-left',
        )}
      >
        {children}
      </div>
    </div>
  )
}

export function StatePage({
  children,
  illustration = false,
  alert = false,
}: {
  readonly children: ReactNode
  readonly illustration?: StateIllustration | false
  readonly alert?: boolean
}) {
  return (
    <main className="flex min-h-dvh items-center justify-center px-6 py-8 sm:px-8">
      <section role={alert ? 'alert' : undefined} className="w-full max-w-md">
        <StateLayout scale="page" illustration={illustration}>
          {children}
        </StateLayout>
      </section>
    </main>
  )
}
